import { ADVANCED_SEARCH, KEYWORD_SEARCH } from "../ActionTypes"

const compare = (a, b) => {
	if (a.last_modified > b.last_modified) return -1
	if (b.last_modified > a.last_modified) return 1
	return 0
}
const initialState = {
	result: [],
	resultkeyword: [],
	LastEvaluatedKey: {},
	LastEvaluatedKeyKeyword: {},
	loading: true
}

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case ADVANCED_SEARCH + "_FULFILLED":
			return {
				...state,
				result: payload.data.advancedSearch.data.sort(compare),
				LastEvaluatedKey: payload.data.advancedSearch.next_token,
				loading: false
			}
		case ADVANCED_SEARCH + "_PENDING":
			return { ...state, loading: true }
		case ADVANCED_SEARCH + "_REJECTED":
			return { ...state, loading: false }
		case KEYWORD_SEARCH + "_FULFILLED":
			return {
				...state,
				resultkeyword: payload.data.keywordSearch.data.sort(compare),
				LastEvaluatedKeyKeyword: payload.data.keywordSearch.next_token,
				loading: false
			}
		case KEYWORD_SEARCH + "_PENDING":
			return { ...state, loading: true }
		case KEYWORD_SEARCH + "_REJECTED":
			return { ...state, loading: false }
		default:
			return state
	}
}
